import { api_endpoints } from '../constants';

// User API Services
export const submitUserData = async (userData) => {
    try {
        const response = await fetch(api_endpoints.create_user, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(userData),
        });
        if (!response.ok) {
            throw new Error('Failed to create user');
        }
        return await response.json();
    } catch (error) {
        console.error('Error creating user:', error);
        throw error;
    }
};

// Event API Services
export const createEvent = async (eventData) => {
    try {
        const response = await fetch(api_endpoints.create_event, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(eventData),
        });
        if (!response.ok) {
            throw new Error('Failed to create event');
        }
        return await response.json();
    } catch (error) {
        console.error('Error creating event:', error);
        throw error;
    }
};

// Board API Services
export const getBoardByBoardNumber = async (boardNum) => {
    try {
        const response = await fetch(api_endpoints.get_board_by_board(boardNum));
        if (!response.ok) {
            throw new Error(`Failed to fetch board for board ${boardNum}`);
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching board by board number:', error);
        throw error;
    }
};

export const getTodaysBoard = async () => {
    try {
        const response = await fetch(api_endpoints.get_todays_board);
        if (!response.ok) {
            throw new Error('Failed to fetch today\'s board');
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching today\'s board:', error);
        throw error;
    }
};

export const submitEventData = async (eventData) => {
    try {
        const response = await fetch(api_endpoints.submit_event_data, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(eventData),
        });
        if (!response.ok) {
            throw new Error('Failed to submit board data');
        }
        return await response.json();
    } catch (error) {
        console.error('Error submitting board data:', error);
        throw error;
    }
};